"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataDeletionFormValidator = exports.TicketFormValidator = void 0;
const zod_1 = require("zod");
const Ticket_1 = require("../types/Ticket");
const Applications_1 = require("../values/Applications");
exports.TicketFormValidator = zod_1.z.object({
    applicationId: zod_1.z.string(),
    priority: zod_1.z.nativeEnum(Ticket_1.TicketPriority, {
        required_error: "Priority is required",
        invalid_type_error: "Priority must be a string"
    }),
    milestoneId: zod_1.z.string(),
    ticketCategoryId: zod_1.z.string().optional(),
    issueDescription: zod_1.z.string({
        required_error: "Description is required",
        invalid_type_error: "Description must be a string"
    }).min(10, "Description must be at least 10 characters long"),
    attachedFileIds: zod_1.z.array(zod_1.z.string()).optional(),
    ref: zod_1.z.string().optional(),
    enquirerName: zod_1.z.string().optional(),
    enquirerEmail: zod_1.z.string().min(1, { message: "Email is required" }).email({ message: "Invalid email" }),
    enquirerPhone: zod_1.z.string().optional(),
    enquirerLanguage: zod_1.z.string().optional(),
}).superRefine((data, ctx) => {
    if (!Applications_1.Applications.find((app) => app.id === data.applicationId)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: "Invalid application ID, valid application IDs are: " + Applications_1.Applications.map((app) => app.id).join(", "),
            path: ["applicationId"]
        });
        return zod_1.z.NEVER;
    }
    // Validate ref prefix if a ref is provided
    if (data.ref) {
        const app = Applications_1.Applications.find((app) => app.id === data.applicationId);
        if (!app?.refPrefix || !data.ref.startsWith(app.refPrefix)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: "ref must start with the application's allowed prefix",
                path: ["ref"]
            });
            return zod_1.z.NEVER;
        }
    }
    // Validate ticketCategoryId if provided
    if (data.ticketCategoryId) {
        const app = Applications_1.Applications.find((app) => app.id === data.applicationId);
        const categories = app?.ticketCategories || [];
        const exists = categories.some(c => c.id === data.ticketCategoryId);
        if (!exists) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: "Invalid ticket category for selected application",
                path: ["ticketCategoryId"]
            });
            return zod_1.z.NEVER;
        }
    }
});
exports.DataDeletionFormValidator = zod_1.z.object({
    applicationId: zod_1.z.string(),
    reason: zod_1.z.string({
        required_error: "Reason is required",
        invalid_type_error: "Reason must be a string"
    }).min(10, "Reason must be at least 10 characters long"),
    enquirerName: zod_1.z.string().optional(),
    enquirerEmail: zod_1.z.string().min(1, { message: "Email is required" }).email({ message: "Invalid email" }),
    enquirerPhone: zod_1.z.string().optional(),
}).superRefine((data, ctx) => {
    if (!Applications_1.Applications.find((app) => app.id === data.applicationId)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: "Invalid application ID, valid application IDs are: " + Applications_1.Applications.map((app) => app.id).join(", "),
            path: ["applicationId"]
        });
        return zod_1.z.NEVER;
    }
});
